export const MANAGEMENT_FILTER_SUBMIT_SUCCESS = "MANAGEMENT_FILTER_SUBMIT_SUCCESS";
export const MANAGEMENT_SELECTED_ROW = "MANAGEMENT_SELECTED_ROW";
export const MANAGEMENT_SELECTED_ROW_SUCCESS = "MANAGEMENT_SELECTED_ROW_SUCCESS";
export const MANAGEMENT_UPDATE_SELECTED_ROW = "MANAGEMENT_UPDATE_SELECTED_ROW";
export const MANAGEMENT_SELECTED_ROW_BY_ISSUES_SUCCESS = "MANAGEMENT_SELECTED_ROW_BY_ISSUES_SUCCESS";
export const MANAGEMENT_FILTER_SUBMIT_SUCCESS_NO_GROUPING = "MANAGEMENT_FILTER_SUBMIT_SUCCESS_NO_GROUPING";